import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, Button, Column, ProgressBar, Row, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import styles from './OnboardingLayout.module.scss';
export const GetOnboardingLayoutTID = (parentTestId)=>getTestIds({
        parentTestId
    });
export const OnboardingLayout = (param)=>{
    let { testId, progress, title, subtitle, children, onBack, onContinue, onSkip, continueLabel, skipLabel, showSkipButton = false, isContinueDisabled = false } = param;
    const testIds = useMemo(()=>GetOnboardingLayoutTID(testId), [
        testId
    ]);
    const { t } = useLocaleKeys('vendorOnboarding.onboardingLayout');
    return /*#__PURE__*/ _jsxs(Column, {
        className: styles.root,
        testId: testIds.OnboardingLayoutTestIds.Root(),
        children: [
            /*#__PURE__*/ _jsxs(Row, {
                className: styles.header,
                alignItems: "center",
                gap: 12,
                children: [
                    onBack && /*#__PURE__*/ _jsx(Button, {
                        skin: "primaryOutline",
                        size: "small",
                        onClick: onBack,
                        testId: testIds.OnboardingLayoutTestIds.BackButton(),
                        children: "←"
                    }),
                    /*#__PURE__*/ _jsx(Box, {
                        className: styles.progressBarContainer,
                        children: /*#__PURE__*/ _jsx(ProgressBar, {
                            completed: progress,
                            total: 100,
                            variant: "steps",
                            testId: testIds.OnboardingLayoutTestIds.ProgressBar()
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Column, {
                className: styles.content,
                testId: testIds.OnboardingLayoutTestIds.Content(),
                children: [
                    title && /*#__PURE__*/ _jsx(Typography, {
                        variant: "h2",
                        testId: testIds.OnboardingLayoutTestIds.Title(),
                        children: title
                    }),
                    subtitle && /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph2",
                        testId: testIds.OnboardingLayoutTestIds.Subtitle(),
                        children: subtitle
                    }),
                    children
                ]
            }),
            /*#__PURE__*/ _jsxs(Row, {
                className: styles.footer,
                justifyContent: "end",
                gap: 12,
                children: [
                    showSkipButton && onSkip && /*#__PURE__*/ _jsx(Button, {
                        skin: "primaryOutline",
                        onClick: onSkip,
                        testId: testIds.OnboardingLayoutTestIds.SkipButton(),
                        children: skipLabel !== null && skipLabel !== void 0 ? skipLabel : t.skip()
                    }),
                    onContinue && /*#__PURE__*/ _jsx(Button, {
                        skin: "primary",
                        onClick: onContinue,
                        disabled: isContinueDisabled,
                        testId: testIds.OnboardingLayoutTestIds.ContinueButton(),
                        children: continueLabel !== null && continueLabel !== void 0 ? continueLabel : t.continue()
                    })
                ]
            })
        ]
    });
};
